import * as o from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/Keyboard.es.js";
const e = o.forwardRef((r, a) => /* @__PURE__ */ o.createElement(t, { ref: a, ...r, weights: m }));
e.displayName = "KeyboardIcon";
const n = e;
export {
  n as Keyboard,
  e as KeyboardIcon
};
